import { authApi, SessionAction } from "@/entities/session";
import { isErr } from "@/shared/utils";
import { Dispatch, RefObject, useEffect } from "react";

export const useSessionBootstrap = (
    dispatch: Dispatch<SessionAction>,
    tokenRef: RefObject<string | null>
) => {
    useEffect(() => {
        const controller = new AbortController();

        (async () => {
            const sessionResult = await authApi.refresh(controller.signal);
            if (controller.signal.aborted) return;

            if (isErr(sessionResult)) {
                dispatch({ type: 'AUTH_FAILURE' });
                return;
            }

            const userResult = await authApi.getUserInfo(controller.signal);
            if (controller.signal.aborted) return;

            if (isErr(userResult)) {
                dispatch({ type: 'AUTH_FAILURE' });
                return;
            }

            tokenRef.current = sessionResult.data.accessToken;
            dispatch({ type: 'AUTH_SUCCESS', user: userResult.data });
        })();

        return () => controller.abort();
    }, []);

}